(()=>{
const PURE='Pure Fragrance Oil',READY='Ready-Made Perfume';
const init=()=>{
 const picker=document.querySelector('[data-product-format-root]');
 const selects=[...document.querySelectorAll('[data-inquiry-format]')];
 if(picker?.dataset.formatReady||(!picker&&!selects.length))return;
 if(picker)picker.dataset.formatReady='true';
 let format=picker?.querySelector('[name="product_format"]:checked')?.value||selects[0]?.value||PURE;
 const key='adl-format-selection:'+location.pathname;
 try{const saved=sessionStorage.getItem(key);if([PURE,READY].includes(saved)){format=saved;sessionStorage.removeItem(key);}}catch{}
 const fromUrl=new URLSearchParams(location.search).get('format');if([PURE,READY].includes(fromUrl))format=fromUrl;
 const update=(next,changeUrl=false)=>{
  format=next===READY?READY:PURE;
  if(picker)picker.querySelectorAll('[name="product_format"]').forEach(el=>el.checked=el.value===format);
  selects.forEach(el=>el.value=format);
  document.querySelectorAll('[data-format-description]').forEach(el=>el.hidden=el.dataset.formatDescription!==format);
  document.querySelectorAll('[data-format-finished-fields]').forEach(el=>{el.hidden=format!==READY;el.querySelectorAll('input,select,textarea').forEach(input=>input.disabled=format!==READY);});
  const selected=selects[0]?.selectedOptions[0]?.textContent||picker?.querySelector('[name="product_format"]:checked+span strong')?.textContent||format;
  document.querySelectorAll('[data-summary-format]').forEach(el=>el.textContent=selected);
  const variant=picker?.dataset[format===READY?'readyVariant':'pureVariant'];
  document.querySelectorAll('[data-inquiry-format-variant]').forEach(el=>el.value=variant||el.value);
  if(changeUrl&&variant){const url=new URL(location.href);url.searchParams.set('variant',variant);url.searchParams.delete('format');history.replaceState({},'',url);}
 };
 picker?.addEventListener('change',e=>{if(e.target.matches('[name="product_format"]'))update(e.target.value,true);});
 selects.forEach(select=>{if(select.dataset.formatReady)return;select.dataset.formatReady='true';select.addEventListener('change',()=>update(select.value,true));});
 document.querySelectorAll('[data-inquiry-login]').forEach(link=>link.addEventListener('click',()=>{try{sessionStorage.setItem(key,format);}catch{}}));
 window.addEventListener('pageshow',()=>update(picker?.querySelector('[name="product_format"]:checked')?.value||selects[0]?.value||format));
 update(format,!!picker);
};
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init);
})();
